export const flatMapThatTree = nodes =>
  nodes.reduce((acc, node) => {
    const { childNodes, ...rest } = node;
    if (childNodes) {
      return [...acc, rest, ...flatMapThatTree(childNodes)];
    }
    return [rest, ...acc];
  }, []);

export default flatMapThatTree;
